import { SVGPropsIcon } from 'src/types';

export const EnLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={`w-[25px] h-[25px] ${props.className}`}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4_7321)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M2.48032 4.69409C1.53771 5.92048 0.826945 7.334 0.413086 8.86958H6.6558L2.48032 4.69409Z"
          fill="#0052B4"
        />
        <path
          d="M23.5864 8.86953C23.1725 7.334 22.4617 5.92048 21.5191 4.69409L17.3438 8.86953H23.5864Z"
          fill="#0052B4"
        />
        <path
          d="M0.413086 15.1304C0.826992 16.6659 1.53776 18.0794 2.48032 19.3058L6.65566 15.1304H0.413086Z"
          fill="#0052B4"
        />
        <path
          d="M19.3053 2.48061C18.0789 1.538 16.6655 0.827236 15.1299 0.41333V6.656L19.3053 2.48061Z"
          fill="#0052B4"
        />
        <path
          d="M4.69434 21.5193C5.92073 22.4619 7.33424 23.1727 8.86977 23.5866V17.344L4.69434 21.5193Z"
          fill="#0052B4"
        />
        <path
          d="M8.86973 0.41333C7.3342 0.827236 5.92068 1.538 4.69434 2.48056L8.86973 6.65595V0.41333Z"
          fill="#0052B4"
        />
        <path
          d="M15.1299 23.5866C16.6654 23.1727 18.0789 22.4619 19.3053 21.5194L15.1299 17.344V23.5866Z"
          fill="#0052B4"
        />
        <path
          d="M17.3438 15.1304L21.5191 19.3058C22.4617 18.0795 23.1725 16.6659 23.5864 15.1304H17.3438Z"
          fill="#0052B4"
        />
        <path
          d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z"
          fill="#D80027"
        />
        <path
          d="M15.1309 15.1304L20.4857 20.4852C20.732 20.239 20.9669 19.9817 21.191 19.7148L16.6066 15.1304H15.1309V15.1304Z"
          fill="#D80027"
        />
        <path
          d="M8.86951 15.1306H8.86941L3.51465 20.4854C3.76084 20.7317 4.01823 20.9666 4.28504 21.1908L8.86951 16.6062V15.1306Z"
          fill="#D80027"
        />
        <path
          d="M8.86976 8.8696V8.86951L3.51495 3.51465C3.26866 3.76084 3.03373 4.01823 2.80957 4.28504L7.39409 8.86955H8.86976V8.8696Z"
          fill="#D80027"
        />
        <path
          d="M15.1309 8.86956L20.4857 3.51465C20.2395 3.26837 19.9821 3.03344 19.7153 2.80933L15.1309 7.39384V8.86956Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7321">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NlLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_7235)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M11.9997 0C6.84013 0 2.44161 3.2565 0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0Z"
          fill="#A2001D"
        />
        <path
          d="M11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094C2.44161 20.7434 6.84012 23.9999 11.9997 23.9999Z"
          fill="#0052B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7235">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SeLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M9.39165 10.4348H23.8987C23.1317 4.54697 18.0972 0 12.0003 0C11.1043 0 10.2316 0.0990469 9.3916 0.285234V10.4348H9.39165Z"
        fill="#0052B4"
      />
      <path
        d="M6.26084 10.4347V1.45898C2.96581 3.25683 0.607016 6.55453 0.101562 10.4347H6.26084V10.4347Z"
        fill="#0052B4"
      />
      <path
        d="M6.2608 13.5652H0.101562C0.607016 17.4454 2.96581 20.7431 6.26084 22.5409L6.2608 13.5652Z"
        fill="#0052B4"
      />
      <path
        d="M9.3916 13.5652V23.7147C10.2316 23.9009 11.1043 24 12.0003 24C18.0972 24 23.1317 19.453 23.8987 13.5652H9.3916V13.5652Z"
        fill="#0052B4"
      />
    </svg>
  );
};

export const EsLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4_7292)">
        <path
          d="M0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174L12 17.2175L23.2536 16.174C23.736 14.874 24 13.4679 24 12.0001C24 10.5322 23.736 9.12618 23.2536 7.8262L12 6.78271L0.746391 7.8262C0.264047 9.12618 0 10.5322 0 12.0001H0Z"
          fill="#FFDA44"
        />
        <path
          d="M23.2533 7.82611C21.5578 3.25655 17.1593 0 11.9997 0C6.84012 0 2.44161 3.25655 0.746094 7.82611H23.2533Z"
          fill="#D80027"
        />
        <path
          d="M0.746094 16.1738C2.44161 20.7434 6.84012 23.9999 11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7292">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FrLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_7156)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M23.9999 11.9999C23.9999 6.84037 20.7434 2.44185 16.1738 0.746338V23.2536C20.7434 21.558 23.9999 17.1595 23.9999 11.9999Z"
          fill="#D80027"
        />
        <path
          d="M0 11.9999C0 17.1595 3.25655 21.558 7.82611 23.2536V0.746338C3.25655 2.44185 0 6.84037 0 11.9999Z"
          fill="#0052B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7156">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const GrLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4_7165)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M12 8.86947H23.5866C23.2857 7.75319 22.8284 6.70126 22.2387 5.73901H12V8.86947Z"
          fill="#338AF3"
        />
        <path
          d="M4.53058 21.3914H19.4702C20.5654 20.5192 21.5046 19.4597 22.2391 18.261H1.76172C2.4963 19.4597 3.43548 20.5192 4.53058 21.3914Z"
          fill="#338AF3"
        />
        <path
          d="M4.17433 2.90332C3.23092 3.71571 2.41534 4.67238 1.76172 5.73907H4.17433V2.90332Z"
          fill="#338AF3"
        />
        <path
          d="M12 12.0001C12 10.7778 12 9.75482 12 8.86963H7.30434V12.0001H4.17389V8.86963H0.413391C0.144375 9.86779 0 10.9169 0 12.0001C0 13.0832 0.144375 14.1324 0.413391 15.1305H23.5867C23.8556 14.1324 24 13.0832 24 12.0001H12Z"
          fill="#338AF3"
        />
        <path
          d="M12.0003 0C10.334 0 8.74703 0.339984 7.30469 0.953812V5.73914H12.0003C12.0003 4.64639 12.0003 3.717 12.0003 2.60869H19.4702C17.4203 0.976125 14.8245 0 12.0003 0Z"
          fill="#338AF3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7165">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DeLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_7162)">
        <path
          d="M0.746094 16.1738C2.44161 20.7434 6.84012 23.9999 11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738L11.9997 15.1304L0.746094 16.1738Z"
          fill="#FFDA44"
        />
        <path
          d="M11.9997 0C6.84012 0 2.44161 3.2565 0.746094 7.82611L11.9997 8.86955L23.2533 7.82606C21.5578 3.2565 17.1593 0 11.9997 0Z"
          fill="black"
        />
        <path
          d="M0.746391 7.82617C0.264047 9.12616 0 10.5322 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174H23.2537C23.736 14.874 24 13.4679 24 12.0001C24 10.5322 23.736 9.12616 23.2536 7.82617H0.746391Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7162">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PtLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_7259)">
        <path
          d="M0 11.9999C0 17.1595 3.2565 21.558 7.82602 23.2535L8.86955 11.9999L7.82602 0.746338C3.2565 2.4419 0 6.84037 0 11.9999Z"
          fill="#6DA544"
        />
        <path
          d="M24.0002 12C24.0002 5.37262 18.6275 0 12.0002 0C10.5323 0 9.1262 0.264047 7.82617 0.746391V23.2536C9.1262 23.736 10.5323 24 12.0002 24C18.6275 24 24.0002 18.6274 24.0002 12Z"
          fill="#D80027"
        />
        <path
          d="M7.82623 16.174C10.1314 16.174 12.0001 14.3052 12.0001 12.0001C12.0001 9.69489 10.1314 7.82617 7.82623 7.82617C5.52106 7.82617 3.65234 9.69489 3.65234 12.0001C3.65234 14.3052 5.52106 16.174 7.82623 16.174Z"
          fill="#FFDA44"
        />
        <path
          d="M5.47852 9.91309V12.5218C5.47852 13.8184 6.52964 14.8696 7.82634 14.8696C9.12305 14.8696 10.1742 13.8185 10.1742 12.5218V9.91309H5.47852Z"
          fill="#D80027"
        />
        <path
          d="M7.82657 13.3043C7.39504 13.3043 7.04395 12.9532 7.04395 12.5217V11.4783H8.60915V12.5218C8.60915 12.9532 8.25805 13.3043 7.82657 13.3043Z"
          fill="#F0F0F0"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7259">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AuLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4_7086)">
        <path
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z"
          fill="#0052B4"
        />
        <path d="M12.0001 0C11.9994 0 11.9987 0.000213 11.998 0.000213L12.0001 0Z" fill="#F0F0F0" />
        <path
          d="M11.9678 11.9999H11.9999C11.9999 11.989 11.9999 11.9786 11.9999 11.9678C11.9892 11.9785 11.9785 11.9892 11.9678 11.9999Z"
          fill="#F0F0F0"
        />
        <path
          d="M12 6.2611C12 4.14962 12 2.76601 12 0.000244141H11.998C5.3715 0.00132227 0 5.37343 0 12.0002H6.26086V8.47464L9.78642 12.0002H11.9679C11.9787 11.9895 11.9894 11.9788 12 11.9681C12 11.1596 12 10.4383 12 9.78671L8.47444 6.2611H12Z"
          fill="#F0F0F0"
        />
        <path
          d="M6.07124 1.56519C4.19441 2.63389 2.63413 4.19417 1.56543 6.071V12H4.69588V4.69569V4.69564H12.0002C12.0002 3.70831 12.0002 2.76772 12.0002 1.56519H6.07124Z"
          fill="#D80027"
        />
        <path
          d="M11.9998 10.5244L7.73641 6.26101H6.26074C6.26074 6.26096 6.26074 6.26101 6.26074 6.26101L11.9998 12.0001H11.9998C11.9998 12.0001 11.9998 10.9826 11.9998 10.5244Z"
          fill="#D80027"
        />
        <path
          d="M7.23729 14.0869L7.89588 15.464L9.38309 15.1203L8.71709 16.4938L9.91305 17.4422L8.42398 17.7779L8.42815 19.3043L7.23729 18.3493L6.04648 19.3043L6.05065 17.7779L4.56152 17.4422L5.75754 16.4938L5.09145 15.1203L6.57874 15.464L7.23729 14.0869Z"
          fill="#F0F0F0"
        />
        <path
          d="M17.9668 16.6956L18.2961 17.3841L19.0397 17.2122L18.7066 17.899L19.3047 18.3732L18.5601 18.541L18.5622 19.3042L17.9668 18.8267L17.3714 19.3042L17.3734 18.541L16.6289 18.3732L17.2269 17.899L16.8939 17.2122L17.6375 17.3841L17.9668 16.6956Z"
          fill="#F0F0F0"
        />
        <path
          d="M14.9033 9.39111L15.2326 10.0797L15.9762 9.90777L15.6432 10.5945L16.2412 11.0688L15.4967 11.2366L15.4987 11.9998L14.9033 11.5223L14.3079 11.9998L14.3099 11.2366L13.5654 11.0688L14.1634 10.5945L13.8304 9.90777L14.574 10.0797L14.9033 9.39111Z"
          fill="#F0F0F0"
        />
        <path
          d="M17.9668 5.21729L18.2961 5.90588L19.0397 5.73399L18.7067 6.42075L19.3046 6.89494L18.5601 7.0628L18.5622 7.82602L17.9668 7.3485L17.3714 7.82602L17.3734 7.0628L16.6289 6.89494L17.2268 6.42075L16.8939 5.73399L17.6375 5.90588L17.9668 5.21729Z"
          fill="#F0F0F0"
        />
        <path
          d="M20.6426 8.34766L20.9718 9.03625L21.7155 8.86431L21.3825 9.55108L21.9805 10.0253L21.2359 10.1932L21.238 10.9563L20.6426 10.4789L20.0472 10.9563L20.0492 10.1932L19.3047 10.0253L19.9027 9.55108L19.5697 8.86431L20.3133 9.03625L20.6426 8.34766Z"
          fill="#F0F0F0"
        />
        <path
          d="M18.729 12L18.988 12.7972H19.8262L19.1481 13.2899L19.4072 14.087L18.729 13.5943L18.0509 14.087L18.3099 13.2899L17.6318 12.7972H18.47L18.729 12Z"
          fill="#F0F0F0"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7086">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NzLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4_7236)">
        <path
          d="M24 12.0002C24 18.6276 18.6274 24.0002 12 24.0002C5.37262 24.0002 0 18.6276 0 12.0002C0 12.0031 12 0.00155664 12 0.000244141C18.6274 0.000244141 24 5.37287 24 12.0002Z"
          fill="#0052B4"
        />
        <path
          d="M11.9678 12.0001H11.9999C11.9999 11.9893 11.9999 11.9788 11.9999 11.968C11.9892 11.9788 11.9785 11.9894 11.9678 12.0001Z"
          fill="#F0F0F0"
        />
        <path
          d="M12 6.2611C12 4.14962 12 2.7661 12 0.000244141H11.998C5.3715 0.00136914 0 5.37348 0 12.0002H6.26086V8.47473L9.78642 12.0002H11.9679C11.9786 11.9896 11.9894 11.9789 12 11.9681C12 11.1597 12 10.4383 12 9.78671L8.47444 6.2611H12Z"
          fill="#F0F0F0"
        />
        <path
          d="M6.07124 1.56519C4.19441 2.63389 2.63413 4.19417 1.56543 6.071V12H4.69588V4.69573V4.69564H12.0002C12.0002 3.70831 12.0002 2.76772 12.0002 1.56519H6.07124Z"
          fill="#D80027"
        />
        <path
          d="M11.9998 10.5244L7.73641 6.26099C7.73641 6.26099 6.26074 6.26108 6.26074 6.26099V6.26108L11.9998 12.0001H11.9998C11.9998 12.0001 11.9998 10.9826 11.9998 10.5244Z"
          fill="#D80027"
        />
        <path
          d="M20.7808 8.9043L21.0398 9.70145H21.878L21.1999 10.1941L21.4589 10.9912L20.7808 10.4986L20.1027 10.9912L20.3617 10.1941L19.6836 9.70145H20.5218L20.7808 8.9043Z"
          fill="#D80027"
        />
        <path
          d="M17.7854 14.6433L18.174 15.8391H19.4312L18.414 16.578L18.8026 17.7738L17.7854 17.0348L16.7682 17.7738L17.1568 16.578L16.1396 15.8391H17.3969L17.7854 14.6433Z"
          fill="#D80027"
        />
        <path
          d="M17.8988 5.2522L18.2226 6.24871H19.2703L18.4226 6.86442L18.7464 7.86088L17.8988 7.24499L17.0512 7.86088L17.3749 6.86442L16.5273 6.24871H17.575L17.8988 5.2522Z"
          fill="#D80027"
        />
        <path
          d="M15.0149 8.86963L15.4034 10.0654H16.6607L15.6435 10.8043L16.0321 12.0001L15.0149 11.2611L13.9977 12.0001L14.3863 10.8043L13.3691 10.0654H14.6264L15.0149 8.86963Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7236">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CaLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4_7116)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M24.0004 12C24.0004 7.24242 21.2317 3.13167 17.2178 1.19067V22.8092C21.2317 20.8682 24.0004 16.7575 24.0004 12Z"
          fill="#D80027"
        />
        <path
          d="M0 12C0 16.7575 2.76867 20.8682 6.78263 22.8092V1.19067C2.76867 3.13167 0 7.24242 0 12Z"
          fill="#D80027"
        />
        <path
          d="M14.087 13.5653L16.174 12.5218L15.1305 12.0001V10.9566L13.0435 12.0001L14.087 9.9131H13.0435L12.0001 8.3479L10.9566 9.9131H9.91309L10.9566 12.0001L8.86961 10.9566V12.0001L7.82617 12.5218L9.91309 13.5653L9.39138 14.6088H11.4783V16.174H12.5218V14.6088H14.6088L14.087 13.5653Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7116">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SlLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_102_195)">
        <mask
          id="mask0_102_195"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24">
          <rect width="24" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_102_195)">
          <path fillRule="evenodd" clipRule="evenodd" d="M0 0V24H24V0H0Z" fill="#2E42A5" />
          <mask
            id="mask1_102_195"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 0V24H24V0H0Z" fill="white" />
          </mask>
          <g mask="url(#mask1_102_195)">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 0V8H24V0H0Z" fill="#F7FCFF" />
            <path fillRule="evenodd" clipRule="evenodd" d="M0 16V24H24V16H0Z" fill="#C51918" />
          </g>
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5475 4.7518C11.5475 4.7518 9.95546 4 7.97539 4C5.99532 4 4.40332 4.7518 4.40332 4.7518C4.40332 4.7518 4.58049 7.77335 4.8605 9.37402C4.98006 10.0575 5.55471 11.0543 6.07496 11.5261C6.66794 12.0638 7.97539 12.7009 7.97539 12.7009C8.35374 12.4402 9.06116 12.323 9.96537 11.5261C10.8696 10.7291 11.0943 9.37402 11.0943 9.37402L11.5475 4.7518Z"
          fill="#2E42A5"
        />
        <path
          d="M11.337 4.65283L12 4.98392L11.5449 9.53935C11.3855 10.5035 10.9866 11.2638 10.3488 11.826C10.0028 12.1309 9.665 12.3587 9.3029 12.5481C9.0985 12.6549 8.24352 13.0953 8.25097 13.0918C8.16531 13.133 8.10035 13.1692 8.04758 13.2056L7.96489 13.2625L7.87561 13.219C6.99006 12.7875 6.16385 12.2068 5.75328 11.8345C5.19281 11.3262 4.60186 10.2861 4.47587 9.56594C4.28749 8.48911 4.11856 7.0059 4 4.98392L4.59558 4.67234C4.71324 6.67909 4.85528 8.27878 5.04026 9.33618C5.1497 9.96178 5.69464 10.9209 6.19176 11.3717C6.55916 11.7049 7.15106 12.0743 7.96489 12.4761C8.01343 12.4477 8.06723 12.4195 8.12878 12.3899C8.13051 12.389 8.68412 12.1432 8.87652 12.0426C9.21398 11.8661 9.52765 11.6545 9.8506 11.3699C10.4168 10.8709 10.7702 10.1989 10.9131 9.34515L11.337 4.65283Z"
          fill="#C51918"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.34644 9.28114C5.34644 9.28114 5.73653 10.4746 6.41969 11.1407C7.10285 11.8068 7.94738 12.1333 7.94738 12.1333C7.94738 12.1333 8.95328 11.829 9.52419 11.1881C10.0951 10.5473 10.6795 9.28114 10.6795 9.28114L9.35187 8.00694L8.82416 8.57958L7.94738 7.32959L7.21334 8.57958L6.65048 8.00694L5.34644 9.28114Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5604 5.39474H6.02856L6.44105 5.00832L6.02856 4.59998H6.5604L6.78495 4.20361L7.01041 4.59998H7.54134L7.14947 4.98379L7.49743 5.39474H7.01041L6.78495 5.81302L6.5604 5.39474Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.06674 5.39474H8.53491L8.9474 5.00832L8.53491 4.59998H9.06674L9.2913 4.20361L9.51676 4.59998H10.0477L9.65582 4.98379L10.0038 5.39474H9.51676L9.2913 5.81302L9.06674 5.39474Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.65952 6.66623H7.12769L7.54017 6.2798L7.12769 5.87146H7.65952L7.88407 5.4751L8.10953 5.87146H8.64046L8.2486 6.25528L8.59655 6.66623H8.10953L7.88407 7.08451L7.65952 6.66623Z"
          fill="#FECA00"
        />
      </g>
      <defs>
        <clipPath id="clip0_102_195">
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_7258)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12" fill="#D80027" />
      </g>
      <defs>
        <clipPath id="clip0_4_7258">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ItLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_7187)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M23.9999 11.9999C23.9999 6.84037 20.7434 2.44185 16.1738 0.746338V23.2536C20.7434 21.558 23.9999 17.1595 23.9999 11.9999Z"
          fill="#D80027"
        />
        <path
          d="M0 11.9999C0 17.1595 3.2565 21.558 7.82611 23.2536V0.746338C3.2565 2.44185 0 6.84037 0 11.9999Z"
          fill="#6DA544"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7187">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RoLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={`${props.className} w-full h-full`}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_7265)">
        <path
          d="M16.1745 0.746344C14.8744 0.264047 13.4684 6.23894e-09 12.0006 6.23894e-09C10.5327 -4.68688e-05 9.12667 0.264047 7.82669 0.746344L6.7832 12L7.82669 23.2536C9.12663 23.736 10.5327 24 12.0006 24C13.4684 24 14.8745 23.736 16.1745 23.2536L17.2179 12L16.1745 0.746344Z"
          fill="#FFDA44"
        />
        <path
          d="M23.9999 11.9999C23.9999 6.84042 20.7434 2.44181 16.1738 0.746338V23.2537C20.7434 21.558 23.9999 17.1596 23.9999 11.9999Z"
          fill="#D80027"
        />
        <path
          d="M0 12.0001C0 17.1598 3.2565 21.5582 7.82602 23.2538L7.82606 0.746582C3.2565 2.44205 0 6.84052 0 12.0001H0Z"
          fill="#0052B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7265">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
